/* =============================================================
   Maybe Sammy Cocktails — global.js
   Small vanilla-JS islands. No dependencies.
   ============================================================= */
(function () {
  'use strict';
  var Routes = window.MSRoutes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Body scroll lock ---------- */
  var lockCount = 0;
  function lockScroll() { lockCount++; document.documentElement.style.overflow = 'hidden'; }
  function unlockScroll() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.documentElement.style.overflow = ''; }

  /* ---------- Drawers (cart / menu / search) ---------- */
  var openDrawer = null;
  function getOverlay() {
    var ov = $('#ms-overlay');
    if (!ov) { ov = document.createElement('div'); ov.id = 'ms-overlay'; ov.className = 'ms-overlay'; document.body.appendChild(ov); }
    return ov;
  }
  function show(drawer) {
    if (!drawer) return;
    closeAll(true);
    var ov = getOverlay();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    ov.classList.add('is-open');
    lockScroll();
    openDrawer = drawer;
    var focusable = drawer.querySelector('[autofocus], button, a, input, select, textarea');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }
  function closeAll(silent) {
    $$('.ms-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    var ov = $('#ms-overlay'); if (ov) ov.classList.remove('is-open');
    if (openDrawer && !silent) unlockScroll();
    if (silent && openDrawer) unlockScroll();
    openDrawer = null;
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ms-drawer-open]');
    if (opener) { e.preventDefault(); show($('#ms-' + opener.getAttribute('data-ms-drawer-open') + '-drawer')); return; }
    if (e.target.closest('[data-ms-drawer-close]') || e.target.id === 'ms-overlay') { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (openDrawer) closeAll();
    var el = document.activeElement;
    if (el && el.closest && el.closest('.ms-nav__item--mega')) el.blur();
  });

  /* ---------- Cart ---------- */
  function refreshCart(openAfter) {
    return fetch('/?sections=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#ms-cart-drawer-content');
        var current = $('#ms-cart-drawer-content');
        if (fresh && current) current.replaceWith(fresh);
        var countEl = doc.querySelector('[data-cart-count]');
        var count = countEl ? parseInt(countEl.getAttribute('data-cart-count'), 10) : null;
        if (count !== null) updateCount(count);
        if (openAfter) show($('#ms-cart-drawer'));
      });
  }
  function updateCount(n) {
    $$('[data-ms-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function addToCart(body, btn) {
    if (btn) { btn.dataset.label = btn.textContent; btn.textContent = (window.MSStrings && window.MSStrings.adding) || 'Adding…'; btn.setAttribute('aria-disabled', 'true'); }
    return fetch(Routes.cart_add || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw res.data; }
        return refreshCart(true);
      })
      .catch(function (err) { console.warn('[cart] add failed', err); if (err && err.description) alert(err.description); })
      .then(function () { if (btn) { btn.textContent = btn.dataset.label; btn.removeAttribute('aria-disabled'); } });
  }
  // Product form submit
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ms-product-form]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var body = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) }] };
    var props = {};
    fd.forEach(function (v, k) { if (k.indexOf('properties[') === 0) { props[k.slice(11, -1)] = v; } });
    if (Object.keys(props).length) body.items[0].properties = props;
    var sp = fd.get('selling_plan');
    if (sp) body.items[0].selling_plan = sp;
    addToCart(body, form.querySelector('[data-ms-add-btn]'));
  });
  // Quick-add / cross-sell buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ms-quick-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart({ items: [{ id: btn.getAttribute('data-variant-id'), quantity: 1 }] }, btn);
  });
  // Qty change + remove inside cart drawer
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-ms-qty]');
    if (step) {
      var wrap = step.closest('.ms-qty'); var input = wrap.querySelector('input');
      var val = parseInt(input.value, 10) || 0;
      val += step.getAttribute('data-ms-qty') === 'up' ? 1 : -1;
      input.value = Math.max(0, val);
      changeLine(step.closest('[data-line]'));
    }
    var rm = e.target.closest('[data-ms-remove]');
    if (rm) { e.preventDefault(); var row = rm.closest('[data-line]'); var inp = row.querySelector('input'); if (inp) inp.value = 0; changeLine(row); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-line] .ms-qty input')) changeLine(e.target.closest('[data-line]'));
  });
  function changeLine(row) {
    if (!row) return;
    var line = row.getAttribute('data-line');
    var qty = parseInt(row.querySelector('input').value, 10) || 0;
    fetch(Routes.cart_change || '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function () { refreshCart(false); });
  }

  /* ---------- Tabs (homepage showcase) ---------- */
  function initTabs(root) {
    $$('[data-ms-tabs]', root).forEach(function (group) {
      var tabs = $$('[data-ms-tab]', group);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-ms-tab');
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          $$('[data-ms-tab-panel]', group).forEach(function (p) { p.hidden = p.getAttribute('data-ms-tab-panel') !== key; });
        });
      });
    });
  }

  /* ---------- Collection filter chips (client-side, faithful to prototype) ---------- */
  function initFilters(root) {
    $$('[data-ms-filter-group]', root).forEach(function (group) {
      var chips = $$('[data-ms-filter]', group);
      var gridSel = group.getAttribute('data-ms-filter-target');
      var grid = gridSel ? $(gridSel) : null;
      if (!grid) return;
      var countEl = group.querySelector('[data-ms-filter-count]');
      var noun = group.getAttribute('data-ms-filter-noun') || 'pours';
      var attr = group.getAttribute('data-ms-filter-attr') || 'data-spirit';
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var val = chip.getAttribute('data-ms-filter');
          chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          var shown = 0;
          $$('[' + attr + ']', grid).forEach(function (item) {
            var match = val === 'all' || (item.getAttribute(attr) || '').toLowerCase().split(',').indexOf(val.toLowerCase()) !== -1;
            item.hidden = !match;
            if (match) shown++;
          });
          if (countEl) countEl.textContent = shown + ' ' + noun;
        });
      });
    });
  }

  /* ---------- Now-playing mini player ---------- */
  function initPlayer(root) {
    var player = $('[data-ms-player]', root);
    if (!player) return;
    var tracks = []; try { tracks = JSON.parse(player.getAttribute('data-tracks') || '[]'); } catch (e) {}
    var i = 0, playing = true;
    var vinyls = $$('.ms-player__vinyl, .ms-player__mini', player);
    var trackEl = $('[data-track-title]', player);
    var playIcon = $('[data-play-icon]', player);
    function render() { if (trackEl && tracks[i]) trackEl.textContent = tracks[i]; vinyls.forEach(function (v) { v.classList.toggle('ms-spin', playing); }); if (playIcon) playIcon.dataset.state = playing ? 'pause' : 'play'; }
    player.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pl]'); if (!a) return;
      var act = a.getAttribute('data-pl');
      if (act === 'play') playing = !playing;
      if (act === 'next') i = (i + 1) % tracks.length;
      if (act === 'prev') i = (i - 1 + tracks.length) % tracks.length;
      if (act === 'min') { player.classList.add('is-min'); return; }
      if (act === 'open') { player.classList.remove('is-min'); return; }
      render();
    });
    render();
  }

  /* ---------- Sticky-aware media gallery is pure CSS; nothing needed ---------- */

  /* ---------- Product form (variant + selling-plan switching) ---------- */
  function initProductForm(root) {
    $$('[data-ms-product-form]', root).forEach(function (form) {
      var dataEl = form.querySelector('[data-ms-variants]');
      if (!dataEl) return;
      var variants = []; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = form.querySelector('input[name="id"]');
      var optionInputs = $$('[data-ms-option]', form);
      var planInput = form.querySelector('[data-ms-selling-plan]');
      var freqSel = form.querySelector('[data-ms-freq]');
      function chosen() {
        var o = {};
        optionInputs.forEach(function (i) {
          if (i.type === 'radio') { if (i.checked) o[i.getAttribute('data-ms-option')] = i.value; }
          else o[i.getAttribute('data-ms-option')] = i.value;
        });
        return o;
      }
      function match() {
        var o = chosen();
        return variants.filter(function (v) {
          return (!o['1'] || v.option1 === o['1']) && (!o['2'] || v.option2 === o['2']) && (!o['3'] || v.option3 === o['3']);
        })[0];
      }
      function subPlanId() { return freqSel ? freqSel.value : (planInput ? planInput.getAttribute('data-default') : ''); }
      function isSub() { var r = form.querySelector('[data-ms-purchase]:checked'); return !!(r && r.value === 'sub'); }
      function planPrice(v, id) { if (!id || !v.plans) return null; for (var i = 0; i < v.plans.length; i++) { if (String(v.plans[i].id) === String(id)) return v.plans[i].price; } return null; }
      function update() {
        var v = match(); if (!v) return;
        if (idInput) idInput.value = v.id;
        var spid = isSub() ? subPlanId() : '';
        if (planInput) planInput.value = spid;
        var pp = planPrice(v, spid);
        var shown = (pp != null) ? pp : v.price;
        var price = form.querySelector('[data-ms-price]'); if (price) price.innerHTML = shown;
        var cmp = form.querySelector('[data-ms-compare]');
        if (cmp) { if (pp != null) { cmp.innerHTML = v.price; cmp.hidden = false; } else if (v.compare) { cmp.innerHTML = v.compare; cmp.hidden = false; } else cmp.hidden = true; }
        form.querySelectorAll('[data-ms-btn-price]').forEach(function (el) { el.innerHTML = v.available ? (' — ' + shown) : ''; });
        var lbl = form.querySelector('[data-ms-btn-label]'); if (lbl) lbl.textContent = v.available ? (window.MSStrings.addToCart || 'Add to cart') : (window.MSStrings.soldOut || 'Sold out');
        var btn = form.querySelector('[data-ms-add-btn]'); if (btn) { btn.disabled = !v.available; if (!v.available) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled'); }
        var subEl = form.querySelector('[data-ms-sub-price]'); if (subEl) { var sp = planPrice(v, subPlanId()); if (sp != null) subEl.innerHTML = sp; }
        var otEl = form.querySelector('[data-ms-ot-price]'); if (otEl) otEl.innerHTML = v.price;
      }
      optionInputs.forEach(function (i) { i.addEventListener('change', update); });
      // subscribe / one-time cards
      $$('[data-ms-purchase]', form).forEach(function (r) {
        r.addEventListener('change', function () {
          $$('[data-ms-sub-card]', form).forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-ms-sub-card') === r.value); });
          update();
        });
      });
      if (freqSel) {
        freqSel.addEventListener('click', function (e) { e.stopPropagation(); });
        freqSel.addEventListener('change', function () {
          var sub = form.querySelector('[data-ms-purchase="sub"]');
          if (sub && !sub.checked) { sub.checked = true; $$('[data-ms-sub-card]', form).forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-ms-sub-card') === 'sub'); }); }
          update();
        });
      }
      // reflect chip selection styling
      optionInputs.forEach(function (i) {
        if (i.type === 'radio') i.addEventListener('change', function () {
          $$('[data-ms-option="' + i.getAttribute('data-ms-option') + '"]', form).forEach(function (r) {
            var lab = form.querySelector('label[for="' + r.id + '"]'); if (lab) lab.classList.toggle('is-active', r.checked);
          });
        });
      });
      update();
    });
  }

  /* ---------- Mega menu (aria sync) ---------- */
  function initMega(root) {
    $$('.ms-nav__item--mega', root).forEach(function (item) {
      var trigger = item.querySelector('[data-mega-trigger]');
      if (!trigger || item.dataset.megaBound) return;
      item.dataset.megaBound = '1';
      function set(state) { trigger.setAttribute('aria-expanded', state ? 'true' : 'false'); }
      item.addEventListener('mouseenter', function () { set(true); });
      item.addEventListener('mouseleave', function () { set(false); });
      item.addEventListener('focusin', function () { set(true); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) set(false); });
    });
  }

  function initAll(root) {
    initTabs(root || document);
    initFilters(root || document);
    initPlayer(root || document);
    initProductForm(root || document);
    initMega(root || document);
  }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#ms-cart-drawer') || e.target.id === 'shopify-section-cart-drawer') return;
  });

  window.MSCart = { refresh: refreshCart, add: addToCart, open: function () { show($('#ms-cart-drawer')); } };
})();